import React, { useContext, useEffect, useState } from 'react'
import { Field, Formik, Form, ErrorMessage, useField } from 'formik';
import { getImages } from '../Const';
import { UserContext } from '../Context/UserContext';

const EmailBuilderModal = ({
        close, pdfFileName, emailScripts, 
        leadData, leadFields, sendPlainTextEmail, 
        fetchPdf, generateText, numberFormatter
    }) => {

    const defaultBody = 'Hi [first_name],\r\n\r\nPlease find your appraisal attached. This offer is valid for 7 days. Please call us if any questions.\r\n\r\nThanks,\r\n[agent_first_name]\r\n954-366-1757';
    const defaultSubject = 'Please find your CarDrop Appraisal Attached';

    const {user} = useContext(UserContext);

    const [emailBody,setEmailBody] = useState(defaultBody);
    const [emailSubject,setEmailSubject] = useState(defaultSubject);
    const [customerEmail,setCustomerEmail] = useState("");
    const [agentEmail,setAgentEmail] = useState("");

    useEffect(() => {
        if (!emailScripts) return; // Ensure script exists
    
        let this_script = defaultBody
    
        // Ensure leadData and leadFields are defined
        if (leadData && leadFields) {
            console.log(leadData);
            leadFields.forEach((field) => {
                const fieldValue = field in leadData ? leadData[field] : "";
                this_script = this_script.replaceAll(`[${field}]`, fieldValue);
            });
        } 

        setEmailBody(this_script);

        setCustomerEmail(leadData && 'email' in leadData ? leadData.email : '');
        setAgentEmail(leadData && 'agent_email' in leadData ? leadData.agent_email : '')
    
        
    },[leadData,emailScripts.length]);

    const sendEmail = async (values) => {

        values.lead_id = leadData?.id || "";
        values.pdf_file = await fetchPdf();

        console.log(values);

        const response = await sendPlainTextEmail(values, leadData, user);

        if (response && response.success) {
            close();
            alert('Your email has been sent');
            //handleTabClick("AppraisalMain");
        } else alert('Error sending email');
    }

    const [selectedOption, setSelectedOption] = useState(0);
    const handleSelectChange = (value) => {
        setSelectedOption(value);

        //console.log("selecting value",value,leadData,emailScripts,leadFields);

        if (value !== null && Array.isArray(emailScripts) && value in emailScripts) {

        var this_subject = emailScripts[value].subject;
        var this_script = emailScripts[value].script;

        leadFields.map((field) => {
            var text_value = leadData[field];
            if(field == "appraisal") {
            text_value = !leadData[field] ? "$XX,XXX" : numberFormatter(leadData[field],true);
            }
            this_subject = this_subject.replaceAll('[' + field + ']',text_value || "");
            this_script = this_script.replaceAll('[' + field + ']',text_value || "");
        });

        setEmailSubject(this_subject);
        setEmailBody(this_script);
        }
    };

    return (
        <>
            <div className="modal-content p-0">
                <Formik
                    initialValues={{
                        email: customerEmail,
                        cc: agentEmail,
                        subject: emailSubject,
                        message: emailBody
                    }}
                    onSubmit={(values, { resetForm }) => {
                        sendEmail(values);
                        //resetForm();
                        //close();
                    }}
                    enableReinitialize={true}
                >
                    {({ values, errors, touched, isValid }) => (
                        <Form className='custom-form appraisal-form email-builder-form'>
                            <div className="modal-header">
                                <h1 className="modal-title text-uppercase text-start w-100 text-white" id="staticBackdropLabel">
                                    Email Printout {leadData && leadData.vehicle_name ? " - " + leadData.vehicle_name : ""}
                                </h1>
                                <button className="sm-box-close" type="button" onClick={close}>
                                    <i className="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                            <div className="modal-body white-bg px-3">
                                <div className='form-group'>
                                    <div className='d-flex align-items-end justify-content-between mb-2'>
                                        <label className='mb-0'>Customer Email</label>
                                        <div>
                                                <button
                                                    // onClick={() => {
                                                    // // close();
                                                    //     onAddScriptBtnClick("email");
                                                    // }}
                                                    className="text-nowrap blue-transparent-btn dark-transparent-btn text-uppercase"
                                                    type="button"
                                                >
                                                    <span className="blue-add-icon"></span> Add script
                                                </button>
                                        </div>
                                    </div>
                                    <Field name="email" type="text" className='form-control' />
                                </div>
                                <div className='form-group'>
                                    <label>Agent Email</label>
                                    <Field name="cc" type="text" className='form-control' />
                                </div>
                                <div className="form-group">
                                    <label>Select Script</label>
                                    <select
                                        name="script"
                                        className="form-control"
                                        onChange={(e) => handleSelectChange(e.target.value)}
                                        value={selectedOption}
                                        >
                                        {emailScripts.map((script,i) => 
                                            <option key={i} value={i}>{script.script_name}</option>
                                        )}
                                    </select>
                                </div>
                                <div className='form-group'>
                                    <label>Subject</label>
                                    <Field name="subject" type="text" className='form-control' />
                                </div>
                                <div className='form-group'>
                                    <label>Message</label>
                                    <Field as="textarea" name="message" className='form-control h-180' />
                                </div>
                                {pdfFileName &&
                                    <div className='form-group text-uppercase'>
                                        <img src={getImages('pdf.png')} style={{maxWidth: '24px'}}/> {pdfFileName}
                                    </div>
                                }
                                <div className='form-group text-end mb-0'>
                                    {!generateText && <button type='submit' className='blue-btn text-uppercase'>Send Email</button>}
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    )
}

export default EmailBuilderModal